import { useVisibleT } from "@/lib/cms/cms-new-i18n";
import { MAX_SHORTCUTS } from "@/lib/dashboard-home/shortcuts";
import { cn } from "@/lib/utils";

/** « 8 / 12 » : nombre de raccourcis sur le maximum autorisé. */
export const ShortcutCounter = ({ count }: { count: number }) => {
  const vt = useVisibleT();
  const full = count >= MAX_SHORTCUTS;
  return (
    <span
      className={cn(
        "shrink-0 rounded-full px-2.5 py-1 text-xs font-medium tabular-nums",
        full ? "bg-amber-100 text-amber-900" : "bg-slate-100 text-slate-600",
      )}
      title={vt("bo.home.shortcuts.counter", "Raccourcis utilisés")}
    >
      {count} / {MAX_SHORTCUTS}
    </span>
  );
};
